<template>
  <div class="w-full items-center">
    <div class="w-full lg:w-1/2 md:w-1/2">
      <div>
        <!--<div>
          <QuestionZero
            v-if="competencyProgressStep === 0"
            :statement="progressStatements[0]"
            :q="0"
          />
        </div>-->
        <div v-if="competencyProgressStep === 0">
          <div class="router-header flex flex-wrap items-center mb-3 mb-base">
            <div
              class="content-area__heading pr-4"
            >
              <div class="mt-2 mb-1">
                <span style="font-size: 25px;">{{ $t("competencyProgress.cp1") }} </span>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="mb-base">
              <vs-button size="large" color="primary" @click="skipTrue"
              >{{ $t("competencyProgress.cp2") }}</vs-button
              >
            </div>
            <div class="mb-base">
              <vs-button size="large" color="danger" @click="skipFalse"
              >{{ $t("competencyProgress.cp3") }}</vs-button
              >
            </div>
          </div>
        </div>
        <div v-if="this.$store.state.competencyProgress.skip === false">
          <div v-for="i in 3" :key="i">
            <Question
              v-if="competencyProgressStep === i"
              :statement="progressStatements[i - 1]"
              :q="i - 1"
            />
          </div>
        </div>
      </div>
      <Result
        v-if="submit === true"
        :progress="progress"
        :practice="practice"
        :relevancy="relevancy"
      />
      <div class="relative">
        <div class="items-center">
          <div v-if="competencyProgressStep > 0" class="vx-col w-full footer-next">
            <div class="vx-card vx-card-next">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                  <div class="vx-row">
                    <div class="vx-col w-full mb-2">
                      <vs-button
                        v-if="competencyProgressStep < 3"
                        class="w-full lg:w-1/2 md:w-1/2 add-skill-step-back-next"
                        color="primary"
                        type="filled"
                        :disabled="disabledNextButton === false"
                        @click="checkNext"
                      >{{ $t("competencyProgress.cp4") }}</vs-button
                      >

                      <vs-button
                        v-else-if="competencyProgressStep === 3"
                        class="w-full lg:w-1/2 md:w-1/2 add-skill-step-back-next"
                        color="primary"
                        type="filled"
                        @click="saveCompetencyProgress"
                      >{{ $t("competencyProgress.cp5") }}</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ccd from "@/assets/data/charactersistic-competency-definition.js";
import QuestionZero from "./QuestionZero";
import Question from "./Question";
import NoteToCoach from "./NoteToCoach";
import Result from "./Result";

export default {
  name: "CompetencyProgress",
  data() {
    return {
      submit: false,
      competencyProgressStep: 0,
      CCD: this.$t("addNewSkill.data"),
      competencyId: "",
      characteristicId: "",
      competencyNum: "",
      progressStatements: [
        this.$t("competencyProgress.cp6"),
        this.$t("competencyProgress.cp7"),
        this.$t("competencyProgress.cp8")
      ],
      numOfStatements: "",
      traineeCompetenciesId: "",
      progress: 0,
      practice: 0,
      relevancy: 0,
      skip: true
    };
  },
  components: {
    Result,
    NoteToCoach,
    QuestionZero,
    Question
  },
  methods: {
    skipTrue() {
      this.$store.dispatch("competencyProgress/skipTrue").catch(err => {console.log(err)})
      this.saveCompetencyProgress();
    },
    skipFalse() {
      this.$store.dispatch("competencyProgress/skipFalse").catch(err => {console.log(err)})
      this.competencyProgressStep = this.competencyProgressStep + 1;
    },
    checkNext() {
      if (this.$store.state.competencyProgress.skip === false) {
        this.competencyProgressStep = this.competencyProgressStep + 1;
      } else {
        this.saveCompetencyProgress();
      }
    },
    disabledNextButton() {
      return false;
    },
    saveCompetencyProgress() {
      let por = {};
      if(this.$store.state.competencyProgress.skip === false) {
        por = {
          progress: this.$store.state.competencyProgress.progress,
          practice: this.$store.state.competencyProgress.practice,
          relevancy: this.$store.state.competencyProgress.relevancy,
          traineeCompetenciesId: this.$route.params.traineeCompetenciesId
        };
      } else {
        por = {
          progress: 100,
          practice: 100,
          relevancy: 100,
          traineeCompetenciesId: this.$route.params.traineeCompetenciesId
        };
      }

      this.$store
        .dispatch("competencyProgress/saveProgress", por)
        .then(res => {
          console.log("progress saved", res);
          this.progress = por.progress;
          this.practice = por.practice;
          this.relevancy = por.relevancy;
          this.submit = true;
        })
        .catch(err => {
          console.log("progress could not be saved", err);
        });

      // this.$router.push({name: "skill-details", params: { traineeCompetenciesId: this.traineeCompetenciesId }})
    }
  },
  created() {
    this.$store.dispatch("competencyProgress/destroyAllState").catch(err => {console.log("could not destroy state", err)});

    // const id = this.$route.params.traineeCompetenciesId;
    this.traineeCompetenciesId = this.$route.params.traineeCompetenciesId;
    if (
      this.competencyProgressStep === 1 &&
      this.$store.state.competencyProgress.skip === true
    ) {
      // this.competencyProgressStep = 4;
      this.saveCompetencyProgress();
    }
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .footer-next {
    position: fixed;
    bottom: 0;
    /*width: 100%;*/
    width: 100vw;
    left: calc(-50vw + 50%);
  }
}

.vx-card-next {
  margin-top: 2rem;
  /*border-radius: 0;*/
  box-shadow: none;
  -webkit-box-shadow: none;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}

</style>
